import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbIndicesMarket = () => {
  return (
    <div
      className="ht__bradcaump__area_market"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container_market">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>
                Trade Global Indices — Capture the Pulse of the World’s
                Economies
              </h1>
              <p>
                Gain broad exposure to the global markets by trading leading
                stock indices with The Pips. Experience tight spreads, fast
                execution, and powerful analytics, all in one platform.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Start Trading Indices
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbIndicesMarket.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbIndicesMarket;
